<template>
  <Modal
    :title="title"
    :maxWidth="maxWidth"
    v-model="visible"
    @backdrop="closeModal(false)"
  >
    <template #activator="{ on, attrs }">
      <Button
        :title="lc.title"
        icon="$objects-trash-outline"
        iconSize="small"
        color="primary"
        :disabled="actionsDisabled"
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <p
      class="text-paragraph-1"
      v-html="description"
      v-if="domainToRemove.isMain"
    />
    <span class="text-paragraph-1" v-html="confirmText" />
    <template #append>
      <Button
        color="primary"
        text
        v-text="lc.cancelAction"
        :disabled="actionsDisabled"
        @click="closeModal(false)"
      />
      <Button
        color="primary"
        v-text="confirmAction"
        :disabled="actionsDisabled"
        @click="handleRemove"
      />
    </template>
  </Modal>
</template>

<script>
import { Button, Modal, useLocale, useVueRouter, useNotification } from '@locaweb/design-system-vue'
import { NOTIFICATION_DEFAULTS } from '@/consts'
import { computed, ref } from 'vue'
import useRemoveDomains from '@/composables/api/useRemoveDomains'

export default {
  name: 'ModalDeleteDomain',
  components: {
    Modal,
    Button
  },
  props: {
    domainToRemove: {
      type: Object,
      required: true
    },
    temporaryDomain: {
      type: Object,
      required: true
    }
  },
  emits: ['success'],
  setup (props, { emit }) {
    const { execute: executeFetch } = useRemoveDomains()
    const notify = useNotification()
    const { $route } = useVueRouter()

    const visible = ref(false)
    const actionsDisabled = ref(false)

    const lc = useLocale('domains.manageDomain.domainCard.modalDeleteDomain')
    const title = computed(() => { return lc.title[props.domainToRemove.type].replaceValues({ domain: props.domainToRemove.address }) })
    const description = computed(() => { return lc.description.replaceValues({ temporaryDomain: props.temporaryDomain.address }) })
    const confirmText = computed(() => { return lc.confirmText[props.domainToRemove.type].replaceValues({ domain: props.domainToRemove.address }) })
    const confirmAction = computed(() => { return lc.confirmAction[props.domainToRemove.type] })
    const maxWidth = computed(() => { return props.domainToRemove.isMain ? '912' : '683' })
    const siteId = computed(() => $route.params.siteId)
    const domainId = computed(() => props.domainToRemove.id)

    function closeModal () {
      visible.value = false
    }

    function onSuccess () {
      notify.show({ ...NOTIFICATION_DEFAULTS, message: lc.successNotification, state: 'success' })
      emit('success')
      return closeModal()
    }

    function onError () {
      notify.show({ ...NOTIFICATION_DEFAULTS, message: lc.failedNotification, state: 'error' })
      return closeModal()
    }

    const handleRemove = async () => {
      actionsDisabled.value = true
      await executeFetch(
        {
          siteId: siteId.value,
          domainId: domainId.value,
          onSuccess,
          onError
        }
      )
      actionsDisabled.value = false
    }

    return {
      lc,
      title,
      description,
      confirmText,
      confirmAction,
      maxWidth,
      siteId,
      visible,
      actionsDisabled,
      closeModal,
      handleRemove
    }
  }
}
</script>
